<template>
    <div class="colored-container">
        <h3 class="preview-data-message">Original data ({{ previewData.rows.length}} records out of {{ numberOfRows}} in total):</h3>
        <div class="row mb-4">
            <div class="col" v-if="previewData.headers.length">
                <data-table v-bind:data="previewData" v-bind:dataTable="true"></data-table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            numberOfRows: 0,
            previewData: {
                headers: [],
                rows: []
            }
        }
    }
</script>
<style lang="scss">
    @import "../../sass/variables";

</style>
